import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import PatientUsersForm from 'components/ListPatientUsers/PatientUsersForm';

const PatientUsersEdit = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <PatientUsersForm />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("patientList")(PatientUsersEdit);